var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCategoryColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29.6666667px",
    height: "29.6666667px",
    viewBox: "0 0 29.6666667 29.6666667",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Administrateur---Param\\xE8tres",
    transform: "translate(-81.166667, -304.166667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(40.000000, 271.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(36.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    fill: "#AFBC9D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 6.66666667,
    y: 6.66666667,
    width: 10,
    height: 10,
    rx: 1.83333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    fill: "#AFBC9D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 6.66666667,
    y: 23.3333333,
    width: 10,
    height: 10,
    rx: 1.83333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    fill: "#AFBC9D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 23.3333333,
    y: 23.3333333,
    width: 10,
    height: 10,
    rx: 1.83333333
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.3333333,
    y1: 11.6666667,
    x2: 33.3333333,
    y2: 11.6666667,
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.3333333,
    y1: 6.66666667,
    x2: 28.3333333,
    y2: 16.6666667,
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategoryColor);
export default __webpack_public_path__ + "static/media/icon_category_color.9c224a5e801c0937cf8438bf41be680a.svg";
export { ForwardRef as ReactComponent };